const mutation = {
  SET_KURIR: (state: any, payload: any) => {
    state.ListKurir = payload
  },
  SET_DEFAULT_KURIR: (state: any) => {
    state.ListKurir = []
  }
}
export default mutation